module.exports = __webpack_public_path__ + "static/img/m_improvement_1.978cf76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m_improvement_1.png
// module id = X3f9
// module chunks = 1